// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.channels {
  padding: clamp(2.5rem, 5vw, 3.5rem) 0;
}

.channels__intro {
  margin-bottom: 1.75rem;
}

.channels__title {
  max-width: 18ch;
  font-family: var(--font-display);
  font-size: clamp(1.45rem, 3vw, 2rem);
  font-weight: 600;
  line-height: 1.15;
  letter-spacing: -0.03em;
  color: var(--ink);
}

.channels__lead {
  max-width: 42ch;
  margin-top: 0.75rem;
  color: var(--muted);
}

.channels__list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.85rem;
}

.channel {
  display: grid;
  gap: 0.35rem;
  min-height: 7.5rem;
  padding: 1.15rem 1.1rem;
  border: 1px solid var(--line);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.72);
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease,
    transform 0.2s ease;
}

.channel:hover {
  border-color: rgba(47, 107, 82, 0.45);
  background: #fff;
  transform: translateY(-2px);
}

.channel__name {
  font-family: var(--font-display);
  font-size: 1.05rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--ink);
}

.channel__hint {
  font-size: 0.9rem;
  color: var(--muted);
  line-height: 1.35;
}

.channels--demo .channel {
  border-color: rgba(15, 46, 36, 0.14);
}

.channels--leads .channel {
  background: rgba(15, 46, 36, 0.04);
}

@media (max-width: 900px) {
  .channels__list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 520px) {
  .channels__list {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Channels.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;EACrC;;;uBAGqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".channels {\r\n  padding: clamp(2.5rem, 5vw, 3.5rem) 0;\r\n}\r\n\r\n.channels__intro {\r\n  margin-bottom: 1.75rem;\r\n}\r\n\r\n.channels__title {\r\n  max-width: 18ch;\r\n  font-family: var(--font-display);\r\n  font-size: clamp(1.45rem, 3vw, 2rem);\r\n  font-weight: 600;\r\n  line-height: 1.15;\r\n  letter-spacing: -0.03em;\r\n  color: var(--ink);\r\n}\r\n\r\n.channels__lead {\r\n  max-width: 42ch;\r\n  margin-top: 0.75rem;\r\n  color: var(--muted);\r\n}\r\n\r\n.channels__list {\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 0.85rem;\r\n}\r\n\r\n.channel {\r\n  display: grid;\r\n  gap: 0.35rem;\r\n  min-height: 7.5rem;\r\n  padding: 1.15rem 1.1rem;\r\n  border: 1px solid var(--line);\r\n  border-radius: 6px;\r\n  background: rgba(255, 255, 255, 0.72);\r\n  transition:\r\n    border-color 0.2s ease,\r\n    background-color 0.2s ease,\r\n    transform 0.2s ease;\r\n}\r\n\r\n.channel:hover {\r\n  border-color: rgba(47, 107, 82, 0.45);\r\n  background: #fff;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.channel__name {\r\n  font-family: var(--font-display);\r\n  font-size: 1.05rem;\r\n  font-weight: 600;\r\n  letter-spacing: -0.02em;\r\n  color: var(--ink);\r\n}\r\n\r\n.channel__hint {\r\n  font-size: 0.9rem;\r\n  color: var(--muted);\r\n  line-height: 1.35;\r\n}\r\n\r\n.channels--demo .channel {\r\n  border-color: rgba(15, 46, 36, 0.14);\r\n}\r\n\r\n.channels--leads .channel {\r\n  background: rgba(15, 46, 36, 0.04);\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .channels__list {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n}\r\n\r\n@media (max-width: 520px) {\r\n  .channels__list {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
